import { select, take } from "redux-saga/effects";

import { areAllParentEmailAddressesSet } from "state/school_money/selectors";
import { PARENTS_FETCH_COMPLETED, SCHOOLS_FETCH_COMPLETED } from "state/school_money/actions";

/**
 * Block saga until parent email address is set in state
 */
export default function* awaitParentsSaga() {
  while (!( yield select(areAllParentEmailAddressesSet) )) {
    yield take([ PARENTS_FETCH_COMPLETED, SCHOOLS_FETCH_COMPLETED ]);
  }
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/awaitParentsSaga.js